import { useState, useEffect } from "react";
import { Bell, Wifi, WifiOff } from "lucide-react";
import { alertesAPI } from "../../api/services";
import { useSocket } from "../../context/SocketContext";
import { useTranslation } from "react-i18next";

export default function Header({ title, subtitle }) {
  const { t } = useTranslation();
  const [apiAlertCount, setApiAlertCount] = useState(0);
  const { alertCount: socketAlertCount, connected, resetAlertCount, lastAlert } = useSocket();

  useEffect(() => {
    alertesAPI.countNew()
      .then(res => setApiAlertCount(res.data.data.count))
      .catch(() => {});
  }, [lastAlert]);

  const totalAlerts = apiAlertCount + socketAlertCount;

  const handleClick = () => {
    resetAlertCount();
    window.location.href = '/alertes';
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 md:mb-6 gap-2">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-slate-800 dark:text-white">{title}</h1>
        {subtitle && <p className="text-slate-500 dark:text-slate-400 text-xs md:text-sm mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2 md:gap-3">
        <div className="flex items-center gap-1.5 px-2 md:px-2.5 py-1 md:py-1.5 rounded-lg bg-gray-50 dark:bg-gray-800" title={connected ? t('header.live') : t('header.offline')}>
          {connected ? (
            <Wifi size={14} className="text-green-500" />
          ) : (
            <WifiOff size={14} className="text-red-400" />
          )}
          <span className={`text-xs font-medium ${connected ? 'text-green-600' : 'text-red-400'}`}>
            {connected ? t('header.live') : t('header.offline')}
          </span>
        </div>
        <div className="relative">
          <button onClick={handleClick} className="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-gray-700 transition-colors">
            <Bell size={20} className="text-slate-600 dark:text-slate-300 md:w-[22px] md:h-[22px]" />
          </button>
          {totalAlerts > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold">
              {totalAlerts > 99 ? '99+' : totalAlerts}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
